import React from 'react';
import { Col, Row } from 'reactstrap';
import { getProfile, login } from '../../../redux/modules/Account';
import { connect } from 'react-redux';
import LoginForm, { loginFormId } from '../../components/Forms/LoginForm';
import Logo from 'assets/img/logo/img_logo.png';
import { Roles } from 'constants/roles';
import { StorageKeys } from 'constants/storageKeys';
import { setStoredItem } from 'helpers/storageHelper';
import { setCookie } from 'helpers/cookieHelper';

const initialValues = {
  email: '',
  password: '',
};

class SignInPage extends React.Component {
  handleSubmit = (values, dispatch) => {
    setCookie(StorageKeys.IsRemember, values.isRemember, 1);

    dispatch(login(values, loginFormId)).then(resp => {
      this.getUserProfile(dispatch);
    });
  };

  getUserProfile = dispatch => {
    dispatch(getProfile()).then(data => {
      const profile = data.response.data.data;
      setStoredItem(StorageKeys.Profile, profile);
      this.props.history.push('/');
    });
  };


  render() {
    return (
      <Row
        id="signIn"
        style={{
          height: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundImage: 'url(/img/bg/img_login.png)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'left bottom',
        }}
      >
        <Col md={6} lg={{ size: 6, offset: 6 }}>
          <div className="mx-auto" style={{ width: 600 }}>
            <div className="row" style={{ marginBottom: 100 }}>
              <div className="col-12 text-left pl-4 pt-3">
                <img src={Logo} alt="logo" className="mb-3" />
                <h1 className="title"> Welcome to NCTECH</h1>
              </div>
            </div>

            <LoginForm initialValues={initialValues} onSubmit={this.handleSubmit} />
          </div>
        </Col>
      </Row>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    login: (email, password) => dispatch(login(email, password)),
  };
};

export default connect(null, mapDispatchToProps)(SignInPage);
